class ProductTabs {
  constructor(wrapperId) {
    this.wrapper = document.getElementById(wrapperId);
    if (!this.wrapper) return;

    this.navItems = Array.from(this.wrapper.querySelectorAll('.product-tabs__nav-item'));
    this.panels = Array.from(this.wrapper.querySelectorAll('.product-tabs__panel'));
    this.navTrack = this.wrapper.querySelector('.product-tabs__nav');

    this.bindEvents();
    this.bindDragScroll();
  }

  bindEvents() {
    this.navItems.forEach((item) => {
      item.addEventListener('click', () => {
        // Ignore the click that fires right after a mouse-drag gesture,
        // so dragging the tab strip doesn't accidentally switch tabs.
        if (this.suppressClick) return;
        const targetId = item.getAttribute('data-tab-target');
        this.activateTab(targetId, item);
      });
    });
  }

  activateTab(targetId, clickedItem) {
    this.navItems.forEach((item) => {
      const isActive = item === clickedItem;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.id === targetId);
    });
  }

  // ---------- Click-and-drag horizontal scroll (mouse) ----------
  // Native overflow-x scrolling works fine via touch/trackpad, but with the
  // scrollbar hidden there's no way for mouse users to drag it — this adds
  // that behavior manually, same pattern used by most modern carousels.
  bindDragScroll() {
    if (!this.navTrack) return;

    let isDown = false;
    let startX = 0;
    let scrollStart = 0;
    let moved = 0;

    const start = (pageX) => {
      isDown = true;
      moved = 0;
      startX = pageX - this.navTrack.offsetLeft;
      scrollStart = this.navTrack.scrollLeft;
      this.navTrack.classList.add('is-dragging');
    };

    const move = (pageX) => {
      if (!isDown) return;
      const x = pageX - this.navTrack.offsetLeft;
      const walk = x - startX;
      moved = Math.abs(walk);
      this.navTrack.scrollLeft = scrollStart - walk;
    };

    const end = () => {
      if (!isDown) return;
      isDown = false;
      this.navTrack.classList.remove('is-dragging');
      // Only suppress the click if the pointer actually moved a meaningful
      // distance — otherwise a normal tap/click still switches tabs.
      this.suppressClick = moved > 5;
      if (this.suppressClick) {
        setTimeout(() => { this.suppressClick = false; }, 50);
      }
    };

    this.navTrack.addEventListener('mousedown', (e) => {
      start(e.pageX);
      e.preventDefault();
    });
    window.addEventListener('mousemove', (e) => move(e.pageX));
    window.addEventListener('mouseup', end);
    this.navTrack.addEventListener('mouseleave', end);
  }
}

window.ProductTabs = ProductTabs;
